<p>
    You can integrate with a calendar provider below.
    This will allow the scheduled events to show within a personal or shared calendar.
    We recommend setting this up so that people can be reminded about upcoming meetings.
</p>

<adapt-meeting-integration-prompt [alwaysShown]="true"></adapt-meeting-integration-prompt>
